// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZmPv","tabsBox":"styles_tabsBox__2YCQP","createButton":"styles_createButton__1huN5"};